import { ClarityUnmaskDirective } from 'app/shared/directives/clarity-unmask.directive';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuthService } from '@service-features/auth.service';
import { BoButtonComponent } from '@shared-components/bo-button/bo-button.component';
import { ANGULAR_IMPORTS } from 'app/shared/imports/angular.imports';
import { ControlErrorMessagePipe } from 'app/shared/pipes/control-error-message.pipe';
import { Subscription } from 'rxjs';
import { InlineSpinnerComponent } from '@shared-components/inline-spinner/inline-spinner.component';

@Component({
  standalone: true,
  selector: 'gd-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    InlineSpinnerComponent,
    ClarityUnmaskDirective,
    ...ANGULAR_IMPORTS,
    BoButtonComponent,
    ControlErrorMessagePipe,
    MatCheckboxModule,
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  private loadingSubscription: Subscription;

  public inputType: string = 'password';
  public showPassword: boolean = false;

  emailControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.email],
  });
  passwordControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(6)],
  });

  loginForm = new FormGroup({
    email: this.emailControl,
    password: this.passwordControl,
  });

  constructor(private authService: AuthService) {
    this.loadingSubscription = authService.loading$.subscribe(
      (loading) => (this.isLoading = loading),
    );
  }

  get isGoogleAuthEnabled(): boolean {
    return this.authService.isGoogleAuthEnabled;
  }

  ngOnInit(): void {
    void this.authService.completeGoogleLogin();
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
  }

  public logIn(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.authService.onLogin(this.loginForm.getRawValue());
  }

  public continueWithGoogle(): void {
    void this.authService.startGoogleLogin();
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }
}
